import React, { createContext, useState, ReactNode, useContext, useEffect, useRef, Dispatch, SetStateAction } from "react";
import { useParams } from "react-router-dom";
import { Hooks } from 'hooks/commonHooks';
import { MessageType } from 'models/BaseModel';
import { Code } from 'constants/codes'


// Define the context properties
interface CalendarContextProps {
  loading: boolean;
  setLoading: (loading: boolean) => void;
  showMenu: boolean;
  setShowMenu: (showMenu: boolean) => void;
  error: string | null;
  setError: (error: string | null) => void;
  confirm: MessageType; 
  setConfirm: Dispatch<SetStateAction<MessageType>>;
  message: MessageType;
  setMessage: Dispatch<SetStateAction<MessageType>>;
  menuPosition: any;
  setMenuPosition: any;
  iframeRef: any;
  contextMenuRef: any;
  formRef: React.RefObject<HTMLDivElement>;
}

// Create the context
const CalendarContext = createContext<CalendarContextProps | undefined>(undefined);

// Provider Component
export const CalendarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { keyId: paramKeyId } = useParams<{ keyId: string }>();

  // Initialize state
  const [loading, setLoading] = useState<boolean>(true);
  const [showMenu, setShowMenu] = useState<boolean>(false); 
  const [error, setError] = useState<string | null>(null);
  const [confirm, setConfirm] = useState<MessageType>(Code.Message.None);
  const [message, setMessage] = useState<MessageType>(Code.Message.None);
  const [menuPosition, setMenuPosition] = Hooks.Form.Position(); 
  const formRef = useRef<HTMLDivElement | null>(null);

  const iframeRef = Hooks.Form.Frame();
  const contextMenuRef = Hooks.Form.Div();

  return (
    <CalendarContext.Provider value={{ 
      loading, setLoading, 
      showMenu, setShowMenu, 
      error, setError, 
      confirm, setConfirm,
      message, setMessage,
      menuPosition, setMenuPosition, 
      formRef, 
      iframeRef, 
      contextMenuRef  
    }}>
      {children}
    </CalendarContext.Provider>
  );
};

// Custom Hook for using the context
export const useCalendarContext = () => {
  const context = useContext(CalendarContext);
  if (!context) {
    throw new Error("useCalendarContext must be used within a CalendarProvider");
  }
  return context;
};
